/**
 * Whether a workspace shows the Skills entry in the left menu, read from its domain registry.
 *
 * **Opt-out, unlike every other domain the sidebar reads.** Quality and Developer are subsystems a
 * workspace switches on, so they test `enabled === true`. Skills is a menu row that already exists
 * for everyone: an absent row, a still-loading query and a workspace nobody has configured all mean
 * "show it", and only an explicit `false` hides it. Copying the `=== true` shape here would make the
 * row vanish for every workspace until an owner went and enabled it.
 *
 * Lives in its own module because two surfaces answer the same question — the sidebar, to decide
 * whether to render the row, and the Agent tab's toggle, to show its current state — and a
 * duplicated predicate is how the two drift apart.
 */
export function skillsNavVisible(
  domains: readonly { domain: string; enabled: boolean }[] | undefined,
): boolean {
  return (
    domains?.find((domain) => domain.domain === 'skills')?.enabled !== false
  );
}
